import React from 'react';
import { Heading as HeadingBase } from 'system';
export const Heading = props => React.createElement(HeadingBase, Object.assign({
  fontSizeScale: "l",
  fontWeight: "semibold",
  lineHeight: "title"
}, props));